import React, { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from '../form/View'
import Header from '../form/Header'
import Item from '../form/Item'
import Footer from '../form/Footer'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1
  },
  subtitle: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: '600',
    color: theme.colors.primary,
    marginBottom: '24px',
    fontSize: '28px',
    '@media(max-height: 976px)': {
      fontSize: '20px',
    },
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 36px'
  }
}))

function DecisionStep (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ selected, setSelected ] = useState(props.initialData ? props.initialData.flow : null)

  return (
    <View className={styles.root}>
      <Header 
        title={props.msg}
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />
      <View className={styles.content}>
        <div className={styles.subtitle}>
          {props.question}
        </div>
        { props.alternatives.map(alternative => (
          <Item 
            key={alternative.option}
            label={alternative.option}
            onSelect={() => setSelected(alternative.flow)}
            selected={selected === alternative.flow}
          />
        ))}
      </View>
      <Footer 
        onBack={() => props.back()}
        onNext={() => props.next({ flow: selected })}
        disabled={!selected}
      />
    </View>
  )
}

export default DecisionStep